export enum CovidFormFields {
  address = 'address',
  dname = 'dname',
  email = 'email',
  phone = 'phone'
}
